// This icon file is generated automatically.
var RepeatOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 20 20", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M2.26 6.57h1.47c.39-.01.7.3.7.7 0 .39-.3.7-.7.7L.7 8a.7.7 0 01-.7-.7V4.08c0-.4.31-.71.7-.71.39 0 .7.32.7.7v1.13A10.54 10.54 0 0110.24 0c4.41 0 8.11 2.72 9.71 6.92a.71.71 0 01-.4.91.7.7 0 01-.9-.4c-1.4-3.67-4.6-6.01-8.4-6.01a9.2 9.2 0 00-8 5.15zm15.48 6.86h-1.47a.7.7 0 01-.7-.7c0-.39.3-.7.7-.7L19.3 12c.38 0 .7.32.7.7v3.21c0 .4-.31.71-.7.71a.7.7 0 01-.7-.7v-1.13A10.54 10.54 0 019.76 20c-4.41 0-8.11-2.72-9.71-6.92a.71.71 0 01.4-.91.7.7 0 01.9.4c1.4 3.67 4.6 6.01 8.4 6.01a9.2 9.2 0 008-5.15z" } }] }, "name": "repeat", "theme": "outlined" };
export default RepeatOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/RepeatOutlined.js
// module id = 3996
// module chunks = 0